import { NavigateProps } from "react-router-dom";
import { hasPermissionToVesselRoutes } from "@shape/reef-shared";
import { PrivateRoute } from "PrivateRoutes/PrivateRoute";
import { RoutesProps } from "routes";

type PrivateVesselRouteProps = Partial<NavigateProps> &
  Partial<RoutesProps> & {
    element: JSX.Element;
    path?: string;
  };

export const PrivateVesselRoute = ({ element, ...props }: PrivateVesselRouteProps) => {
  return <PrivateRoute {...props} element={element} validation={hasPermissionToVesselRoutes} />;
};
